export const PRE_TRIP_TEMPLATE = [
  {
    title: 'Cab',
    items: [
      { key: 'cab_occupant_door', label: 'Defect - Occupant compartment door fails to open' },
      { key: 'cab_door_close', label: 'Major Defect - Any cab door fails to close securely' },
    ],
  },
  {
    title: 'Cargo Securement',
    items: [
      { key: 'cargo_covering', label: 'Defect - Insecure or improper load covering' },
      { key: 'cargo_insecure', label: 'Major Defect - Insecure cargo' },
      { key: 'cargo_device', label: 'Major Defect - Absence/failure/malfunction/deterioration of required cargo securement device or load covering' },
    ],
  },
  {
    title: 'Coupling Devices',
    items: [
      { key: 'coupler_fastener', label: 'Defect - Coupler or mounting has loose or missing fastener' },
      { key: 'coupler_insecure', label: 'Major Defect - Coupler is insecure or movement exceeds prescribed limit' },
      { key: 'coupler_lock', label: 'Major Defect - Coupling or locking mechanism is damaged or fails to lock' },
      { key: 'safety_chain', label: 'Major Defect - Defective/incorrect/missing safety chain or cable' },
    ],
  },
  {
    title: 'Dangerous Goods',
    items: [
      { key: 'dg_requirements', label: 'Major Defect - Dangerous goods requirements not met' },
    ],
  },
  {
    title: 'Driver Controls',
    items: [
      { key: 'driver_controls', label: 'Defect - Accelerator pedal, clutch, gauges, audible and visual indicators or instruments fail to function properly' },
    ],
  },
  {
    title: 'Driver Seat',
    items: [
      { key: 'seat_position', label: 'Defect - Seat is damaged or fails to remain in set position' },
      { key: 'seatbelt_tether', label: 'Major Defect - Seatbelt or tether belt is insecure, missing, or malfunctions' },
    ],
  },
  {
    title: 'Emergency Equipment & Safety Devices',
    items: [
      { key: 'emergency_equipment', label: 'Defect - Emergency equipment (fire extinguisher, reflective triangles, reflective vest, first aid kit, torch, flashlight, plug-in cord) is missing, damaged, or defective' },
    ],
  },
  {
    title: 'Exhaust System',
    items: [
      { key: 'exhaust_leak', label: 'Defect - Exhaust leak' },
      { key: 'exhaust_into_cab', label: 'Major Defect - Leak that causes exhaust gas to enter the occupant compartment' },
    ],
  },
  {
    title: 'Frame & Cargo Body',
    items: [
      { key: 'frame_damage', label: 'Defect - Damaged frame or cargo body' },
      { key: 'frame_shifted', label: 'Major Defect - Visibly shifted, cracked, collapsing or sagging frame member(s)' },
    ],
  },
  {
    title: 'Fuel System',
    items: [
      { key: 'fuel_cap_missing', label: 'Defect - Missing fuel tank cap' },
      { key: 'fuel_tank_insecure', label: 'Major Defect - Insecure fuel tank' },
      { key: 'fuel_tank_dripping', label: 'Major Defect - Dripping fuel tank' },
    ],
  },
  {
    title: 'General',
    items: [
      { key: 'general_serious_damage', label: 'Major Defect - Serious damage or deterioration that is noticeable and may affect the vehicle’s safe operation' },
    ],
  },
  {
    title: 'Glass and Mirrors',
    items: [
      { key: 'glass_view', label: 'Defect - Required mirror or window glass fails to provide the required view to the driver as a result of being cracked, broken, damaged, missing, or maladjusted' },
      { key: 'glass_attachments', label: 'Defect - Required mirror or glass has broken or damaged attachments onto vehicle body' },
    ],
  },
  {
    title: 'Heater and Defroster',
    items: [
      { key: 'heater_failure', label: 'Defect - Control or system failure' },
      { key: 'defroster_failure', label: 'Major Defect - Defroster fails to provide unobstructed view through the windshield' },
    ],
  },
  {
    title: 'Horn',
    items: [
      { key: 'horn_inop', label: 'Defect - Vehicle has to operative horn' },
    ],
  },
  {
    title: 'Hydraulic Brake System',
    items: [
      { key: 'brake_fluid_low', label: 'Defect - Brake fluid level is below indicated minimum level' },
      { key: 'brake_boost_inop', label: 'Major Defect - Brake boost or power assist is not operative' },
      { key: 'brake_fluid_leak', label: 'Major Defect - Brake fluid leak' },
      { key: 'brake_pedal_fade', label: 'Major Defect - Brake pedal fade or insufficient brake pedal reserve' },
      { key: 'abs_activated', label: 'Major Defect - Activated (other than ABS) warning device' },
      { key: 'reservoir_low', label: 'Major Defect - Brake fluid reservoir is less than ¼ full' },
      { key: 'parking_brake_inop', label: 'Major Defect - Parking brake is inoperative' },
    ],
  },
  {
    title: 'Lamps and Reflectors',
    items: [
      { key: 'lamp_not_function', label: 'Defect - Require lamp does not function as intended' },
      { key: 'reflector_missing', label: 'Defect - Required reflector is missing or partially missing' },
      { key: 'low_beam_failure', label: 'Major Defect - When use of lamps are required: Failure of both low beam headlamps' },
      { key: 'tail_lamps_failure', label: 'Major Defect - When use of lamps are required: Failure of both rearmost tail lamps' },
      { key: 'turn_indicator_failure', label: 'Major Defect - At all times: Failure of a rearmost turn-indicator lamp' },
      { key: 'brake_lamps_failure', label: 'Major Defect - At all times: Failure of both rearmost brake lamps' },
    ],
  },
  {
    title: 'Steering',
    items: [
      { key: 'steering_free_play', label: 'Defect - Steering wheel lash (free play) is greater than normal' },
      { key: 'steering_insecure', label: 'Major Defect - Steering wheel is insecure or does not respond normally' },
      { key: 'steering_exceeds_limit', label: 'Major Defect - Steering wheel lash (free play) exceeds prescribed limit' },
    ],
  },
  {
    title: 'Suspension System',
    items: [
      { key: 'suspension_air_leak', label: 'Defect - Air leak in suspension system' },
      { key: 'spring_leaf_broken', label: 'Defect - Broken spring leaf' },
      { key: 'suspension_fastener', label: 'Defect - Suspension fastener is loose, missing, or broken' },
      { key: 'air_bag_damage', label: 'Major Defect - Damaged (patched, cut, bruised, cracked to braid or deflated) air bag or insecurely mounted air bag' },
      { key: 'main_spring_broken', label: 'Major Defect - Cracked or broken main spring leaf or more than one broken spring leaf' },
      { key: 'spring_part_missing', label: 'Major Defect - Part of spring leaf or suspension is missing, shifted out of place or is in contact with another vehicle component' },
      { key: 'u_bolt_loose', label: 'Major Defect - Loose U-bolt' },
    ],
  },
  {
    title: 'Tires',
    items: [
      { key: 'tire_damage', label: 'Defect - Damaged tread or sidewall of tire' },
      { key: 'tire_leak_not_heard', label: 'Defect - Tire leaking, if leak cannot be heard' },
      { key: 'flat_tire', label: 'Major Defect - Flat tire' },
      { key: 'tire_leak_felt', label: 'Major Defect - Tire leaking, if leak can be felt or heard' },
      { key: 'tread_depth_low', label: 'Major Defect - Tire tread depth is less than wear limit' },
      { key: 'tire_contact_component', label: 'Major Defect - Tire is in contact with another tire or any vehicle component other than mud-flap' },
      { key: 'not_for_highway', label: 'Major Defect - Tire is marked “Not for highway use”' },
      { key: 'cords_exposed', label: 'Major Defect - Tire has exposed cords in the tread or outer sidewall area' },
    ],
  },
  {
    title: 'Wheels, Hubs, and Fasteners',
    items: [
      { key: 'hub_oil_low', label: 'Defect - Hub oil below minimum level (when fitted with sight glass)' },
      { key: 'wheel_seal_leak', label: 'Defect - Leaking wheel seal' },
      { key: 'wheel_fastener', label: 'Major Defect - Wheel has loose, missing, or ineffective fastener' },
      { key: 'wheel_damaged', label: 'Major Defect - Damaged, cracked or broken wheel, rim or attaching part' },
      { key: 'bearing_failure', label: 'Major Defect - Evidence of imminent wheel, hub or bearing failure' },
    ],
  },
  {
    title: 'Windshield Wiper/Washer',
    items: [
      { key: 'wiper_control_failure', label: 'Defect - Control or system malfunction' },
      { key: 'wiper_blade', label: 'Defect - Wiper blade damaged, missing, or fails to adequately clear driver’s field of vision' },
      { key: 'washer_failure', label: 'Major Defect - When use of wipers or washer is required: (a) wiper or washer fails to adequately clear driver’s field of vision in area swept by driver’s side wiper' },
    ],
  },
  {
    title: 'Other',
    items: [
      { key: 'defect_en_route', label: 'Defect En Route (TEXT ONLY)' },
      { key: 'remarks', label: 'Remarks (TEXT ONLY)' },
      { key: 'no_defects', label: 'No Defects Found' },
      { key: 'defects_corrected', label: 'Above Defects Corrected' },
      { key: 'defects_not_required', label: 'Above defects need not be corrected for safe operation of vehicle' },
    ],
  },
];

export const POST_TRIP_TEMPLATE = [
  {
    title: 'Post-Trip Inspection',
    items: [
      { key: 'post_lights_backup_alarm', label: 'Lights and Backup Alarm' },
      { key: 'post_tires', label: 'Tires' },
      { key: 'post_automatic_transmission_fluid', label: 'Automatic Transmission Fluid' },
      { key: 'post_emergency_brake', label: 'Emergency Brake' },
    ],
  },
  {
    title: 'Other',
    items: [
      { key: 'post_defect_en_route', label: 'Defect En Route (TEXT ONLY)' },
      { key: 'post_remarks', label: 'Remarks (TEXT ONLY)' },
      { key: 'post_no_defects', label: 'No Defects Found' },
      { key: 'post_defects_corrected', label: 'Above Defects Corrected' },
      { key: 'post_defects_not_required', label: 'Above defects need not be corrected for safe operation of vehicle' },
    ],
  },
];
